import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"font-size":"14px","line-height":"22px","text-align":"left","font-style":"normal","text-transform":"none","margin":"16px 0 0 10px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#697077"} }, "累计终端结算金额：", -1)
const _hoisted_3 = { style: {"color":"#121619","font-weight":"600"} }

import { WarningFilled } from '@element-plus/icons-vue';
import { previewBill } from '@/utils/download';
import { computed, ref } from 'vue';
import {
  BaseTabs,
  BaseTabPane,
  XrkTable,
  XrkTableProps,
  BaseButton,
  XrkTableRef,
  createDialog,
  BaseIcon,
  BaseTextContent
} from 'xrk-components';
import { date, download } from 'xrk-tools';
import {
  getTerminalPayDetail,
  getTerminalPayList,
  select,
  getTerminalPayListAmount,
  exportTerminalPayListUrl
} from '../data-source/api';
import { TerminalPayListParams } from '../data-source/types';
import { PAYTYPE_MAPPING } from '../constants';
import { batchDownLoadReceipt } from '@/common/hooks/order/order-download';
import { maskAllMethod } from '@/utils/formatter';
import { IS_PLATFORM_TYPE_1 } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-pay',
  setup(__props) {

const xrkTable = ref<XrkTableRef>(null);

/**
 * 2 按项目 1按人展示
 */
const activeType = ref<1 | 2>(1);
const listAmount = ref<string | number>('');
const loading = ref<boolean>(false);

const dealQuery = (query: TerminalPayListParams) => {
  return Object.entries({
    type: activeType.value,
    payDtStart: query.payDt?.[0],
    payDtEnd: query.payDt?.[1],
    ...query
  }).reduce((pre, [key, value]) => {
    if (value) {
      pre[key] = value;
    }
    return pre;
  }, {} as TerminalPayListParams);
};

const getDefaultPayDtValue = () => {
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
  return [date.dateFormat(start, 'Y-M-D'), date.dateFormat(end, 'Y-M-D')];
};

const handleRadioChange = async () => {
  loading.value = true;
  xrkTable.value.clearSearchValues();
  xrkTable.value.setSearchValue('payDt', getDefaultPayDtValue());
  await xrkTable.value.initList();
  loading.value = false;
};

const getList = async (query: TerminalPayListParams) => {
  const _query = dealQuery(query);
  const res = await getTerminalPayList(_query);
  getTerminalPayListAmount(_query).then(res => {
    listAmount.value = res.data.amount;
  });
  return res;
};

const isCloseOrrgType = r => {
  let isCloseOrrgType = !!+r.closeOrRgType && +r.closeOrRgStatus === 2;
  if (r.specialFlag !== undefined) isCloseOrrgType = !!+r.specialFlag;

  return isCloseOrrgType;
};

const tableColumnConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns:
      activeType.value === 1
        ? [
            { label: '序号', type: 'index', width: 60, fixed: 'left' },
            {
              label: '项目参与人',
              prop: 'fullName',
              width: 130,
              formatter: ({ cellValue }) =>
                maskAllMethod({ type: 'name', val: cellValue })
            },
            { label: '手机号', prop: 'phone', width: 130 },
            { label: '项目名称', prop: 'projectName', minWidth: 300 },
            { label: '工业方', prop: 'industryName', minWidth: 300 },
            IS_PLATFORM_TYPE_1 && {
              label: '供应商',
              prop: 'supplierName',
              minWidth: 300
            },
            { label: '实际完成任务量', prop: 'finishSum', width: 130 },
            { label: '终端结算单价', prop: 'taskPrice', width: 120 },
            { label: '终端结算金额', prop: 'taskPriceSum', width: 120 },
            { label: '支付通道', prop: 'payPassagewayName', width: 90 },
            {
              label: '服务商付款方式',
              prop: 'payType',
              formatter: ({ cellValue }) =>
                PAYTYPE_MAPPING?.[cellValue]?.label || '-',
              width: 130
            },
            { label: '支付时间', prop: 'payDt', width: 180 },
            {
              label: '支付状态',
              prop: 'payStatus',
              width: 120,
              render: ({ row }) => {
                return (
                  <div style="display: flex; align-items: center">
                    <span>{row.payStatus}</span>
                    {isCloseOrrgType(row) && (
                      <BaseIcon style="margin-left: 5px" color="red" size={18}>
                        <WarningFilled />
                      </BaseIcon>
                    )}
                  </div>
                );
              }
            },
            {
              label: '操作',
              width: 160,
              fixed: 'right',
              render: ({ row }) => {
                return (
                  <>
                    <BaseButton
                      type={row.bankPayVoucherUrl ? 'primary2' : 'info'}
                      link
                      disabled={!row.bankPayVoucherUrl}
                      click={() => {
                        previewBill(row.bankPayVoucherUrl);
                      }}
                    >
                      查看
                    </BaseButton>
                    <BaseButton
                      v-resource={[['下载回单']]}
                      type={row.bankPayVoucherUrl ? 'primary2' : 'info'}
                      link
                      disabled={!row.bankPayVoucherUrl}
                      click={async () => {
                        download.downloadFile(row.bankPayVoucherUrl, {
                          fileName: `个人回单_${row.fullName}_${row.phone}.pdf`
                        });
                      }}
                    >
                      下载回单
                    </BaseButton>
                  </>
                );
              }
            }
          ].filter(Boolean)
        : [
            { label: '序号', type: 'index', width: 70, fixed: 'left' },
            { label: '项目名称', prop: 'projectName', minWidth: 300 },
            { label: '工业方', prop: 'industryName', minWidth: 300 },
            IS_PLATFORM_TYPE_1 && {
              label: '供应商',
              prop: 'supplierName',
              minWidth: 300
            },
            { label: '实际完成任务量', prop: 'finishSum', width: 130 },
            { label: '终端结算单价', prop: 'taskPrice', width: 120 },
            { label: '终端结算金额', prop: 'taskPriceSum', width: 120 },
            {
              label: '已结算人数',
              prop: 'peopleCount',
              width: 110,
              render: ({ cellValue, row }) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <span>{cellValue || 0}</span>
                    {cellValue > 0 && (
                      <BaseButton
                        type="primary"
                        link
                        onClick={() => {
                          createDialog({
                            title: '结算用户',
                            contentRender: () => (
                              <BaseTextContent>
                                <XrkTable
                                  requestNow
                                  getListAjax={(query: any) =>
                                    getTerminalPayDetail({
                                      customOrderId: row.customOrderId,
                                      projectId: row.projectId,
                                      projectType: row.projectType,
                                      ...query
                                    })
                                  }
                                  tableConfig={{
                                    baseConfig: { height: '42vh' },
                                    tableColumns: [
                                      {
                                        label: '序号',
                                        type: 'index',
                                        width: 70
                                      },
                                      {
                                        label: '项目参与人',
                                        prop: 'fullName',
                                        width: 100
                                      },
                                      {
                                        label: '手机号',
                                        prop: 'phone',
                                        width: 130
                                      },
                                      {
                                        label: '结算时间',
                                        prop: 'finishPayDt',
                                        width: 180
                                      },
                                      {
                                        label: '实际完成任务量',
                                        prop: 'finishSum',
                                        width: 130
                                      },
                                      {
                                        label: '终端结算单价',
                                        prop: 'taskPrice',
                                        width: 110
                                      },
                                      {
                                        label: '终端结算金额',
                                        prop: 'taskPriceSum',
                                        width: 110
                                      },
                                      {
                                        label: '支付状态',
                                        prop: 'payStatus',
                                        width: 120,
                                        render: ({ row }) => {
                                          return (
                                            <div style="display: flex; align-items: center; justify-content: center">
                                              <span>{row.payStatus}</span>
                                              {isCloseOrrgType(row) && (
                                                <BaseIcon
                                                  style="margin-left: 5px"
                                                  color="red"
                                                  size={18}
                                                >
                                                  <WarningFilled />
                                                </BaseIcon>
                                              )}
                                            </div>
                                          );
                                        }
                                      }
                                    ]
                                  }}
                                  searchConfig={{
                                    searchColumns: [
                                      {
                                        type: 'input',
                                        prop: 'fullName',
                                        label: '项目参与人：',
                                        style: { width: '200px' },
                                        config: {
                                          clearable: true
                                        }
                                      },
                                      {
                                        type: 'input',
                                        prop: 'phone',
                                        label: '手机号：',
                                        style: { width: '200px' },
                                        config: {
                                          type: 'tel',
                                          clearable: true
                                        }
                                      }
                                    ]
                                  }}
                                  paginationConfig={{ paginationPageSize: 15 }}
                                ></XrkTable>
                              </BaseTextContent>
                            ),
                            cancelBtnConfig: { show: false }
                          });
                        }}
                      >
                        详情
                      </BaseButton>
                    )}{' '}
                  </div>
                );
              }
            },
            { label: '支付通道', prop: 'payPassagewayName', width: 90 },
            {
              label: '服务商付款方式',
              prop: 'payType',
              formatter: ({ cellValue }) =>
                PAYTYPE_MAPPING?.[cellValue]?.label || '-',
              width: 130
            },
            { label: '支付时间', prop: 'payDt', width: 180 },
            {
              label: '操作',
              width: 120,
              fixed: 'right',
              render: ({ row }) => {
                return (
                  <BaseButton
                    v-resource={[['下载回单']]}
                    type="text"
                    click={async () => {
                      const searchValue = xrkTable.value.getSearchValue();
                      //批量下载回单
                      await batchDownLoadReceipt({
                        downloadType: 505,
                        queryParam: JSON.stringify(
                          dealQuery({
                            downloadType: 2,
                            ...(searchValue as any),
                            orderId: row.customOrderId
                          })
                        )
                      });
                    }}
                  >
                    下载回单
                  </BaseButton>
                );
              }
            }
          ].filter(Boolean)
  };
});

const searchConfig = computed<XrkTableProps['searchConfig']>(() => {
  return {
    searchColumns: [
      {
        type: 'select',
        prop: 'projectId',
        label: '项目名称',
        config: {
          clearable: true,
          filterUseRemote: true,
          placeholder: '请输入关键字',
          labelKey: 'projectName',
          valueKey: 'projectId',
          remoteMethod: async searchVal => {
            return select.getProjectList({
              type: activeType.value,
              keyWord: searchVal
            });
          }
        }
      },
      ...(activeType.value === 1
        ? ([
            {
              type: 'input',
              prop: 'fullName',
              label: '项目参与人',
              style: { width: '200px' },
              config: {
                clearable: true
              }
            },
            {
              type: 'input',
              prop: 'phone',
              label: '手机号',
              style: { width: '200px' },
              config: {
                type: 'tel',
                clearable: true
              }
            }
          ] as XrkTableProps['searchConfig']['searchColumns'])
        : []),
      IS_PLATFORM_TYPE_1 && {
        type: 'select',
        prop: 'supplierEntId',
        label: '供应商',
        config: {
          clearable: true,
          placeholder: '请输入关键字',
          labelKey: 'supplierName',
          valueKey: 'supplierId',
          filterUseRemote: true,
          remoteMethod: async searchVal => {
            return select.getSupplierList({
              type: activeType.value,
              keyWord: searchVal
            });
          }
        }
      },
      {
        type: 'select',
        prop: 'industryEntId',
        label: '工业方',
        config: {
          clearable: true,
          placeholder: '请输入关键字',
          labelKey: 'industryName',
          valueKey: 'industryId',
          filterUseRemote: true,
          remoteMethod: async searchVal => {
            return select.getIndustryList({
              type: activeType.value,
              keyWord: searchVal
            });
          }
        }
      },
      {
        type: 'datePicker',
        prop: 'payDt',
        label: '支付时间',
        defaultValue: getDefaultPayDtValue(),
        config: {
          type: 'daterange'
        }
      }
    ].filter(Boolean),
    otherComponents: [
      {
        render({ searchValue }) {
          return (
            <BaseButton
              v-resource={[['下载回单']]}
              type="primary2"
              click={async () => {
                //批量下载回单
                await batchDownLoadReceipt({
                  downloadType: 505,
                  queryParam: JSON.stringify(
                    dealQuery({
                      downloadType: activeType.value === 1 ? 1 : 3,
                      ...(searchValue as any)
                    })
                  )
                });
              }}
            >
              批量下载回单
            </BaseButton>
          );
        }
      },
      {
        render({ searchValue }) {
          return (
            <BaseButton
              v-resource={[['导出']]}
              type="primary2"
              click={async () => {
                await exportTerminalPayListUrl(dealQuery(searchValue as any));
              }}
            >
              导出
            </BaseButton>
          );
        }
      }
    ]
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTable",
      ref: xrkTable,
      requestNow: true,
      getListAjax: getList,
      "search-config": searchConfig.value,
      tableConfig: tableColumnConfig.value,
      paginationConfig: {
        paginationPageSize: 15
      }
    }, {
      tableTop: _withCtx(() => [
        _createVNode(_unref(BaseTabs), {
          disabled: loading.value,
          modelValue: activeType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeType).value = $event)),
          onTabChange: handleRadioChange
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseTabPane), {
              name: 2,
              label: "按项目展示"
            }),
            _createVNode(_unref(BaseTabPane), {
              name: 1,
              label: "按人展示"
            })
          ]),
          _: 1
        }, 8, ["disabled", "modelValue"])
      ]),
      tableAfter: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(listAmount.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["search-config", "tableConfig"])
  ]))
}
}

})